// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2UserCreateHubUserCreateHubUserResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2UserCreateHubUserCreateHubUserResponse.attributeTypeMap;
    }
}
AuthenticationV2UserCreateHubUserCreateHubUserResponse.discriminator = undefined;
AuthenticationV2UserCreateHubUserCreateHubUserResponse.additionalProperties = false;
AuthenticationV2UserCreateHubUserCreateHubUserResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=authenticationV2UserCreateHubUserCreateHubUserResponse.js.map